export default __webpack_public_path__ + "static/Suzuki Grand Vitara-15819ddb11fb25aec841b6e58bc16113.jpg";